import axios from "axios";
import apiUrlOne from "../Config";

// Create a store counter
export const createStoreCounter = async (storeCounterData) => {
    try {
        const response = await axios.post(
            `${apiUrlOne}/storecounter/create-storecounter`,
            storeCounterData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating store counter:", error.response ? error.response.data : error.message);
        throw error;
    }
};

// Update a store counter by ID
export const updateStoreCounter = async (id, storeCounterData) => {
    try {
        const response = await axios.put(
            `${apiUrlOne}/storecounter/update-storecounter/${id}`,
            storeCounterData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating store counter:", error.response ? error.response.data : error.message);
        throw error;
    }
};

// Get store counters for a specific storeId
export const getStoreCounters = async (storeId) => {
    try {
        const response = await axios.get(
            `${apiUrlOne}/storecounter/getstorecounters/${storeId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching store counters:", error.response ? error.response.data : error.message);
        throw error;
    }
};
